import { EditFilled } from '@ant-design/icons';
import React from 'react';
import { Link } from 'react-router-dom';

const EditModalButton = ({ openModal, id }) => {
  return (
    <div className="ant-button-edit">
      <Link style={{ padding: '0px' }} onClick={() => openModal('edit', id)}>
        <EditFilled className="edit" />
      </Link>
    </div>
  );
};

export default EditModalButton;
